import { jsxs as e, Fragment as t, jsx as r } from "react/jsx-runtime";

import o from "@ui-components-3/ui/lib/components/Drawer";

import i from "@ui-components-3/ui/lib/utils/classNames";

import { useState as s, useContext as n, useMemo as a } from "react";

import { useProviderSchedule as l } from "../../../hooks/useProviderSchedule.js";

import { format as m, addHours as c, addMinutes as u, startOfHour as d, startOfDay as f } from "date-fns";

import p from "./SlotCard.js";

import h from "./SlotsFilters.js";

import { SlotsFiltersSchema as b } from "../../../utils.js";

import y from "@ui-components-3/icons/lib/regular/CalendarDay";

import { useLiveCurrentDate as v } from "../../../hooks/useLiveCurrentDate.js";

import x from "../DrawerEmptyState.js";

const D = b.cast({}), j = () => {
    const [b, j] = s(D), k = v(), {softClose: w} = n(o.context), {variantClassNames: M, slots: g, drawerSlotsFilter: C, schedulesMap: N} = l(), {day: S, hour: F} = C || {}, O = a((() => {
        if (!S && !F) return "";
        if (S) return m(S, "MM/dd/yy");
        if (F) {
            const e = m(F, "h"), t = m(c(new Date(F), 1), "haaa");
            return `${m(F, "MM/dd/yy")}, ${e} - ${t}`;
        }
    }), [ S, F ]), $ = a((() => S || F ? g?.filter((e => {
        const {pastVisits: t, available: r, upcomingVisits: o} = b;
        if (!r && !e.booked) return !1;
        const i = new Date(e.startTime), s = u(new Date(i), e.duration), n = k.valueOf() > s.valueOf();
        if (!t && n && e.booked) return !1;
        if (!o && !n && e.booked) return !1;
        const a = F ? d : f;
        return a(i).valueOf() === a(new Date(F || S || "")).valueOf();
    })) : []), [ S, b, F, k, g ]);
    return e(t, {
        children: [ r(o.Content, {
            children: e("div", {
                className: "flex flex-col gap-4 py-4",
                children: [ e("div", {
                    className: "flex items-center justify-between gap-4",
                    children: [ e("p", {
                        className: i("typography-body-xl flex shrink-0 items-center gap-2 font-semibold", M.textMain),
                        children: [ r(y, {
                            "aria-hidden": "true",
                            className: M.textMain
                        }), O ]
                    }), !!S && r(h, {
                        currentFilters: b,
                        onApply: j
                    }) ]
                }), $?.length ? $?.map((e => r(p, {
                    slot: e,
                    schedule: N?.[e.blockId]
                }, e.id))) : r(x, {
                    description: "There are currently no visits or slots in this time frame."
                }) ]
            })
        }), r(o.Footer, {
            children: r("button", {
                type: "button",
                className: i("btn", M.buttonMain),
                onClick: w,
                children: "Done"
            })
        }) ]
    });
};

export { j as default };
//# sourceMappingURL=index.js.map
